import I18n from 'I18n';
import { useEffect } from 'react';
import { isUngatedForInbound25Selector } from '../selectors/GatingSelectors';
import { useAppSelector } from '../reducers';
import { getInbound25CopyChangeKey } from '../utils/copyChangeUtils';
export const setTitle = title => {
  document.title = title;
};
export const resetTitle = () => {
  const title = I18n.text('pricingPage.windowTitles.default');
  setTitle(title);
};
export const useDocumentTitle = titleKey => {
  const isUngatedForInbound = useAppSelector(isUngatedForInbound25Selector);
  const title = I18n.text(isUngatedForInbound ? getInbound25CopyChangeKey(`pricingPage.windowTitles.${titleKey}`) : `pricingPage.windowTitles.${titleKey}`);
  useEffect(() => {
    setTitle(title);
    return () => resetTitle();
  }, [title]);
};